module.exports = __webpack_public_path__ + "static/tasks-web2-40068fbc0607c15eb7cf3c7fb0664c47.png";